import { useEffect, useState } from "react";
import type { Message } from "../../types/message";
import { MessageBubble } from "./message-bubble";

export default function StickerMessage({ message }: { message: Message }) {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!message.url) return;

    setIsLoading(true);
    setHasError(false);
  }, [message.url]);

  if (!message.url) return null;

  return (
    <MessageBubble message={message}>
      <div
        className={`relative inline-block max-w-full overflow-hidden rounded-lg ${
          isLoading ? "min-h-24 min-w-24" : ""
        }`}
      >
        {hasError ? (
          <div className="flex min-h-24 w-full items-center justify-center bg-slate-200 text-xs text-slate-600">
            Figurinha indisponível
          </div>
        ) : (
          <>
            <div
              className={`absolute inset-0 bg-slate-200 ${
                isLoading ? "animate-pulse" : "opacity-0"
              }`}
              aria-hidden="true"
            />
            <img
              src={message.url}
              alt={message.contentType || "Figurinha"}
              loading="lazy"
              decoding="async"
              onLoad={() => setIsLoading(false)}
              onError={() => {
                setIsLoading(false);
                setHasError(true);
              }}
              className={`max-h-36 max-w-36 rounded-lg object-contain transition-opacity duration-150 ${
                isLoading ? "opacity-0" : "opacity-100"
              }`}
            />
          </>
        )}
      </div>
      {message.caption?.trim() ? (
        <p
          className={`mt-2 whitespace-pre-wrap text-sm leading-snug ${
            message.role === "user" ? "text-slate-700" : "text-slate-100"
          }`}
        >
          {message.caption}
        </p>
      ) : null}
    </MessageBubble>
  );
}
